module.exports = __webpack_public_path__ + "assets/img/Tao.e5e5e4b1.png";